var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSebraeOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 506.773,
    height: 150,
    viewBox: "0 0 506.773 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-253.489 -102.786)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(465.679 185.605)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M557.906,224.666v14.156a7.51,7.51,0,0,1-2,5.556,7.024,7.024,0,0,1-5.189,2,6.809,6.809,0,0,1-5.093-2.007,7.6,7.6,0,0,1-1.963-5.549V224.666h2.984v14.156a6.063,6.063,0,0,0,1.124,3.887,3.6,3.6,0,0,0,2.948,1.4,3.746,3.746,0,0,0,3.035-1.4,5.947,5.947,0,0,0,1.154-3.9V224.666Z",
    transform: "translate(-543.663 -218.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M577.834,242.128h.088l5.13-17.462h3.822v21.4h-2.97v-15.42l-.089-.015-4.909,15.435h-2.044l-4.983-15.67-.089.015v15.655h-2.97v-21.4h3.9Z",
    transform: "translate(-550.425 -218.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M618.675,240.575a3.515,3.515,0,0,0-.838-2.418,7.335,7.335,0,0,0-2.954-1.727,12.117,12.117,0,0,1-4.63-2.426,5.107,5.107,0,0,1-1.618-3.954,5.408,5.408,0,0,1,1.786-4.167A6.507,6.507,0,0,1,615,224.244a6.382,6.382,0,0,1,4.763,1.822,6.059,6.059,0,0,1,1.735,4.572l-.029.088H618.6a4.5,4.5,0,0,0-1-3.043,3.3,3.3,0,0,0-2.631-1.161,3.1,3.1,0,0,0-2.462,1,3.661,3.661,0,0,0-.875,2.5,3.1,3.1,0,0,0,.926,2.307,8.922,8.922,0,0,0,3.117,1.72,10.968,10.968,0,0,1,4.453,2.5,5.434,5.434,0,0,1,1.529,4,5.221,5.221,0,0,1-1.8,4.167,6.988,6.988,0,0,1-4.726,1.551,7.606,7.606,0,0,1-4.91-1.676,5.622,5.622,0,0,1-2.014-4.807l.03-.088h2.881a4.228,4.228,0,0,0,1.153,3.249,4.039,4.039,0,0,0,2.859,1.073,3.533,3.533,0,0,0,2.6-.933A3.371,3.371,0,0,0,618.675,240.575Z",
    transform: "translate(-561.009 -218.246)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M645.925,236a8.169,8.169,0,0,1-2.058,5.931,7.32,7.32,0,0,1-5.512,2.124,7.12,7.12,0,0,1-5.424-2.124A8.277,8.277,0,0,1,630.917,236v-5.88a8.334,8.334,0,0,1,2.014-5.938,7.063,7.063,0,0,1,5.41-2.146,7.318,7.318,0,0,1,5.52,2.139,8.2,8.2,0,0,1,2.065,5.945Zm-2.969-5.924a6.512,6.512,0,0,0-1.2-4.241,4.185,4.185,0,0,0-3.417-1.448,3.973,3.973,0,0,0-3.3,1.448,6.689,6.689,0,0,0-1.154,4.241V236a6.745,6.745,0,0,0,1.161,4.278,3.987,3.987,0,0,0,3.307,1.455,4.163,4.163,0,0,0,3.41-1.448A6.617,6.617,0,0,0,642.956,236Zm-3.44-14.038h3.425l.044.074-3.558,3.836h-2.5Z",
    transform: "translate(-567.112 -216.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M675.924,240.575a3.515,3.515,0,0,0-.838-2.418,7.326,7.326,0,0,0-2.954-1.727A12.127,12.127,0,0,1,667.5,234a5.109,5.109,0,0,1-1.617-3.954,5.41,5.41,0,0,1,1.786-4.167,6.509,6.509,0,0,1,4.579-1.639,6.383,6.383,0,0,1,4.763,1.822,6.062,6.062,0,0,1,1.735,4.572l-.029.088h-2.867a4.5,4.5,0,0,0-1-3.043,3.305,3.305,0,0,0-2.631-1.161,3.1,3.1,0,0,0-2.462,1,3.658,3.658,0,0,0-.875,2.5,3.1,3.1,0,0,0,.926,2.307,8.914,8.914,0,0,0,3.117,1.72,10.977,10.977,0,0,1,4.453,2.5,5.436,5.436,0,0,1,1.529,4,5.219,5.219,0,0,1-1.8,4.167,6.985,6.985,0,0,1-4.725,1.551,7.6,7.6,0,0,1-4.91-1.676,5.622,5.622,0,0,1-2.014-4.807l.029-.088h2.881a4.229,4.229,0,0,0,1.154,3.249,4.04,4.04,0,0,0,2.859,1.073,3.533,3.533,0,0,0,2.6-.933A3.373,3.373,0,0,0,675.924,240.575Z",
    transform: "translate(-576.395 -218.246)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M699.237,236.131h-7.261V243.8h8.555v2.264H688.991v-21.4h11.465v2.293h-8.481v6.893h7.261Z",
    transform: "translate(-582.72 -218.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M709.448,246.068v-21.4h5.924a7.28,7.28,0,0,1,4.8,1.441,5.307,5.307,0,0,1,1.727,4.321,4.793,4.793,0,0,1-.75,2.661,4.377,4.377,0,0,1-2.087,1.705,4.153,4.153,0,0,1,2.874,1.771,5.929,5.929,0,0,1,1.007,3.447,5.794,5.794,0,0,1-1.7,4.505,6.682,6.682,0,0,1-4.681,1.551Zm2.984-12.127h3.4a3.042,3.042,0,0,0,2.256-.934,3.514,3.514,0,0,0-2.711-6.048h-2.94Zm0,2.146V243.8h4.131a3.19,3.19,0,0,0,2.5-.978,4.04,4.04,0,0,0,.882-2.8,4.339,4.339,0,0,0-.86-2.822,3.1,3.1,0,0,0-2.418-1.117h-4.234Z",
    transform: "translate(-588.217 -218.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M735.7,236.857v9.217h-2.984V224.686h6.306a6.721,6.721,0,0,1,4.769,1.573,5.874,5.874,0,0,1,1.683,4.513,5.416,5.416,0,0,1-.786,2.932,5.186,5.186,0,0,1-2.257,1.948,4.1,4.1,0,0,1,2.374,1.852,6.464,6.464,0,0,1,.728,3.205v1.867a8.411,8.411,0,0,0,.191,1.837,2.571,2.571,0,0,0,.676,1.323v.339h-3.072a2.552,2.552,0,0,1-.654-1.477,13.312,13.312,0,0,1-.154-2.051v-1.808a4.436,4.436,0,0,0-.831-2.837,2.778,2.778,0,0,0-2.3-1.044Zm0-2.279h3.175a3.507,3.507,0,0,0,2.734-.977,4,4,0,0,0,.882-2.771,4.279,4.279,0,0,0-.86-2.851,3.231,3.231,0,0,0-2.609-1.014H735.7Z",
    transform: "translate(-594.472 -218.365)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M765.079,240.658h-6.394l-1.544,5.41h-3.1l6.423-21.4h2.9l6.366,21.4h-3.1Zm-5.718-2.366h5.057l-2.469-8.7h-.088Z",
    transform: "translate(-600.202 -218.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M789.667,236.131h-7.261V243.8h8.555v2.264H779.422v-21.4h11.465v2.293h-8.482v6.893h7.261Z",
    transform: "translate(-607.023 -218.36)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(466.236 141.919)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M568.9,164.007a4.086,4.086,0,0,1-.881.869,1.8,1.8,0,0,1-1.033.289,2.1,2.1,0,0,1-1.158-.378q-.579-.377-1.3-.831a10.445,10.445,0,0,0-1.65-.831,6.486,6.486,0,0,0-4.217-.052,4.031,4.031,0,0,0-1.448.906,3.738,3.738,0,0,0-.869,1.359,4.889,4.889,0,0,0-.29,1.712,2.551,2.551,0,0,0,.566,1.688,5.152,5.152,0,0,0,1.51,1.2,15.166,15.166,0,0,0,2.128.945q1.182.429,2.428.932a23.186,23.186,0,0,1,2.442,1.159,8.843,8.843,0,0,1,2.14,1.637,7.423,7.423,0,0,1,1.509,2.367,8.749,8.749,0,0,1,.566,3.324,14.154,14.154,0,0,1-.959,5.211,12.588,12.588,0,0,1-2.745,4.267,13.031,13.031,0,0,1-4.344,2.894,15.469,15.469,0,0,1-8.938.715,16.653,16.653,0,0,1-3.071-1,15.6,15.6,0,0,1-2.732-1.525,10.467,10.467,0,0,1-2.139-1.964l2.921-3.826a2.867,2.867,0,0,1,.869-.7,2.192,2.192,0,0,1,1.045-.276,2.289,2.289,0,0,1,1.372.491q.667.49,1.473,1.083a10.665,10.665,0,0,0,1.876,1.083,6.3,6.3,0,0,0,2.631.492A4.791,4.791,0,0,0,560.148,186a5.006,5.006,0,0,0,1.247-3.688,2.95,2.95,0,0,0-.567-1.863,4.712,4.712,0,0,0-1.485-1.234,12.66,12.66,0,0,0-2.1-.894q-1.184-.389-2.417-.844a20.593,20.593,0,0,1-2.417-1.071,7.478,7.478,0,0,1-3.587-4.055,9.843,9.843,0,0,1-.565-3.563,12.319,12.319,0,0,1,.921-4.7,12.186,12.186,0,0,1,2.632-3.99,12.7,12.7,0,0,1,4.155-2.769,14.789,14.789,0,0,1,8.523-.7,14.147,14.147,0,0,1,2.756.907,12.4,12.4,0,0,1,2.341,1.373,9.5,9.5,0,0,1,1.786,1.726Z",
    transform: "translate(-544.424 -156.301)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M595.036,163.111l-1.085,8.862,10.373,0-.807,6.093-10.322,0-1.136,9.089,13.671,0-.807,6.319-21.9-.007,4.542-36.682,21.853.006-.807,6.319Z",
    transform: "translate(-554.796 -156.432)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M637.024,156.8a21.619,21.619,0,0,1,5.476.606,10.391,10.391,0,0,1,3.726,1.726,6.677,6.677,0,0,1,2.114,2.695,8.841,8.841,0,0,1,.666,3.487,10.751,10.751,0,0,1-.391,2.907,8.225,8.225,0,0,1-1.234,2.581,9.367,9.367,0,0,1-2.166,2.14A12.913,12.913,0,0,1,642,174.58a8.337,8.337,0,0,1,4.379,2.506,6.5,6.5,0,0,1,1.409,4.293,11.655,11.655,0,0,1-.971,4.745,11.041,11.041,0,0,1-2.808,3.839,13.487,13.487,0,0,1-4.469,2.58,17.558,17.558,0,0,1-5.955.942l-13.7,0,4.543-36.682Zm-2.779,30.514a6.485,6.485,0,0,0,2.543-.44,4.257,4.257,0,0,0,1.675-1.233,5,5,0,0,0,.932-1.851,8.8,8.8,0,0,0,.29-2.316,5.025,5.025,0,0,0-.214-1.511,2.539,2.539,0,0,0-.73-1.145,3.61,3.61,0,0,0-1.359-.731,7.023,7.023,0,0,0-2.077-.265h-5.287l-1.161,9.492Zm-2.409-24.4-1.161,9.466H634.6a10.289,10.289,0,0,0,2.493-.276,4.657,4.657,0,0,0,1.9-.943,4.284,4.284,0,0,0,1.221-1.775,7.679,7.679,0,0,0,.429-2.744,3.463,3.463,0,0,0-1.07-2.883,5.319,5.319,0,0,0-3.31-.845Z",
    transform: "translate(-564.706 -156.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M678.55,156.815a20.1,20.1,0,0,1,5.753.72,10.952,10.952,0,0,1,3.89,1.977,7.482,7.482,0,0,1,2.2,2.984,9.963,9.963,0,0,1,.691,3.739,13.448,13.448,0,0,1-.543,3.84,11.881,11.881,0,0,1-4.093,6.042,13.44,13.44,0,0,1-3.4,1.925,6.694,6.694,0,0,1,1.385,1.046,5.369,5.369,0,0,1,1.056,1.5l5.334,12.918-7.4,0a3.3,3.3,0,0,1-1.724-.415,2.354,2.354,0,0,1-.994-1.146l-3.975-10.853a2.225,2.225,0,0,0-.755-.981,2.466,2.466,0,0,0-1.359-.3h-1.838l-1.691,13.7-8.158,0,4.492-36.682Zm-2.069,17.322a7.443,7.443,0,0,0,3-.54,5.428,5.428,0,0,0,2-1.447,5.542,5.542,0,0,0,1.108-2.115,9.347,9.347,0,0,0,.341-2.543,5.522,5.522,0,0,0-.3-1.876,3.552,3.552,0,0,0-.944-1.436,4.444,4.444,0,0,0-1.611-.919,7.146,7.146,0,0,0-2.279-.328h-2.921l-1.388,11.2Z",
    transform: "translate(-576.272 -156.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M734.488,193.516l-6.344,0a2.315,2.315,0,0,1-2.467-1.788l-1.13-6.6-12.463,0-2.722,6.6a3.574,3.574,0,0,1-1.12,1.234,2.917,2.917,0,0,1-1.75.553h-6.445l17.534-36.678,8.409,0Zm-10.9-13.977-1.784-10.474q-.2-.982-.439-2.329t-.465-2.908q-.605,1.586-1.2,2.933t-1.02,2.353l-4.309,10.423Z",
    transform: "translate(-586.247 -156.443)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M763.158,163.159l-1.085,8.862,10.373,0-.807,6.093-10.322,0L760.18,187.2l13.671,0-.807,6.319-21.9-.006,4.542-36.682,21.854.007-.807,6.319Z",
    transform: "translate(-599.979 -156.445)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(659.347 141.869)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M844.21,172.628a23.007,23.007,0,0,1-.694,5.69,21.877,21.877,0,0,1-1.966,5.06,20.373,20.373,0,0,1-3.073,4.254,18.864,18.864,0,0,1-4.042,3.259,19.92,19.92,0,0,1-4.859,2.088,20.126,20.126,0,0,1-5.514.741,15.958,15.958,0,0,1-6.508-1.273,14.428,14.428,0,0,1-4.9-3.476,15.177,15.177,0,0,1-3.082-5.187,18.888,18.888,0,0,1-1.068-6.433,23.066,23.066,0,0,1,.694-5.7,21.768,21.768,0,0,1,1.966-5.072,20.084,20.084,0,0,1,3.085-4.254,19.144,19.144,0,0,1,4.054-3.259,19.941,19.941,0,0,1,4.86-2.088,20.243,20.243,0,0,1,5.539-.741,15.917,15.917,0,0,1,6.483,1.274,14.233,14.233,0,0,1,4.884,3.488,15.419,15.419,0,0,1,3.069,5.213A18.929,18.929,0,0,1,844.21,172.628Zm-8.409.2a14.651,14.651,0,0,0-.54-4.117,9.242,9.242,0,0,0-1.585-3.172,7.1,7.1,0,0,0-2.555-2.04,7.879,7.879,0,0,0-3.424-.719,9.555,9.555,0,0,0-4.507,1.044,9.932,9.932,0,0,0-3.387,2.932,13.816,13.816,0,0,0-2.141,4.544,21.822,21.822,0,0,0-.745,5.879,14.823,14.823,0,0,0,.528,4.1,9.183,9.183,0,0,0,1.547,3.148,6.937,6.937,0,0,0,2.529,2.027,7.95,7.95,0,0,0,3.45.719,9.49,9.49,0,0,0,7.919-3.951,14.007,14.007,0,0,0,2.153-4.531A21.3,21.3,0,0,0,835.8,172.827Z",
    transform: "translate(-808.507 -156.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M894.861,156.8l-4.543,36.682h-4.28a3.291,3.291,0,0,1-1.548-.314,3.421,3.421,0,0,1-1.12-1.046l-12.808-22.663q-.077,1.46-.228,2.618l-2.524,21.4h-7.251l4.542-36.683h4.331a8.761,8.761,0,0,1,.894.038,1.856,1.856,0,0,1,.642.176,1.713,1.713,0,0,1,.5.39,4.812,4.812,0,0,1,.478.655l12.859,22.663c.05-.587.1-1.15.151-1.687s.11-1.041.177-1.511l2.473-20.72Z",
    transform: "translate(-822.496 -156.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M922.432,163.13l-1.086,8.862,10.373,0-.807,6.093-10.324,0-1.135,9.089,13.671,0-.808,6.319-21.9-.007,4.543-36.682,21.854.006L936,163.133Z",
    transform: "translate(-835.894 -156.388)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M415.9,169.638a26.356,26.356,0,1,0,26.355,26.356A26.356,26.356,0,0,0,415.9,169.638Zm0,45.38a19.024,19.024,0,1,1,19.022-19.024A19.022,19.022,0,0,1,415.9,215.018Z",
    transform: "translate(-36.566 -17.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.852,116.718a3.667,3.667,0,1,0,3.668-3.667A3.667,3.667,0,0,0,462.852,116.718Z",
    transform: "translate(-56.266 -2.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M450.2,116.718a3.667,3.667,0,1,0-3.667,3.666A3.667,3.667,0,0,0,450.2,116.718Z",
    transform: "translate(-50.894 -2.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M432.936,127.667A3.668,3.668,0,1,0,436.6,124,3.667,3.667,0,0,0,432.936,127.667Z",
    transform: "translate(-48.226 -5.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M432.939,106.455a3.667,3.667,0,1,0,3.667-3.669A3.664,3.664,0,0,0,432.939,106.455Z",
    transform: "translate(-48.227 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M421.722,116.718a3.667,3.667,0,1,0,3.664-3.667A3.666,3.666,0,0,0,421.722,116.718Z",
    transform: "translate(-45.212 -2.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M409.454,106.455a3.667,3.667,0,1,0,3.667-3.669A3.665,3.665,0,0,0,409.454,106.455Z",
    transform: "translate(-41.915 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M396.123,106.455a3.666,3.666,0,1,0-3.668,3.664A3.668,3.668,0,0,0,396.123,106.455Z",
    transform: "translate(-36.362 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M399.188,116.718a3.667,3.667,0,1,0,3.669-3.667A3.668,3.668,0,0,0,399.188,116.718Z",
    transform: "translate(-39.156 -2.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M416.787,127.664a3.667,3.667,0,1,0-3.666,3.669A3.666,3.666,0,0,0,416.787,127.664Z",
    transform: "translate(-41.915 -5.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M421.722,138.253a3.667,3.667,0,1,0,3.664-3.666A3.666,3.666,0,0,0,421.722,138.253Z",
    transform: "translate(-45.212 -8.546)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M442.863,138.253a3.667,3.667,0,1,0,3.666-3.666A3.665,3.665,0,0,0,442.863,138.253Z",
    transform: "translate(-50.894 -8.546)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M460.6,127.667a3.666,3.666,0,1,0-3.668,3.666A3.666,3.666,0,0,0,460.6,127.667Z",
    transform: "translate(-53.689 -5.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M484.193,138.253a3.667,3.667,0,1,0,3.667-3.666A3.667,3.667,0,0,0,484.193,138.253Z",
    transform: "translate(-62.001 -8.546)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M473.656,127.664A3.666,3.666,0,1,0,477.323,124,3.667,3.667,0,0,0,473.656,127.664Z",
    transform: "translate(-59.17 -5.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.852,138.253a3.667,3.667,0,1,0,3.668-3.666A3.667,3.667,0,0,0,462.852,138.253Z",
    transform: "translate(-56.266 -8.546)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M453.264,148.519a3.666,3.666,0,1,0,3.665-3.668A3.667,3.667,0,0,0,453.264,148.519Z",
    transform: "translate(-53.689 -11.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.852,159.646a3.667,3.667,0,1,0,3.668-3.667A3.668,3.668,0,0,0,462.852,159.646Z",
    transform: "translate(-56.266 -14.296)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M473.656,148.519a3.666,3.666,0,1,0,3.667-3.668A3.667,3.667,0,0,0,473.656,148.519Z",
    transform: "translate(-59.17 -11.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M494.594,148.519a3.666,3.666,0,1,0,3.667-3.668A3.666,3.666,0,0,0,494.594,148.519Z",
    transform: "translate(-64.797 -11.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M480.989,171.971a3.666,3.666,0,1,0-3.666,3.666A3.667,3.667,0,0,0,480.989,171.971Z",
    transform: "translate(-59.17 -17.608)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M484.193,159.646a3.667,3.667,0,1,0,3.667-3.667A3.668,3.668,0,0,0,484.193,159.646Z",
    transform: "translate(-62.001 -14.296)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M504.857,159.646a3.666,3.666,0,1,0,3.669-3.667A3.668,3.668,0,0,0,504.857,159.646Z",
    transform: "translate(-67.555 -14.296)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M494.594,171.971a3.666,3.666,0,1,0,3.667-3.667A3.666,3.666,0,0,0,494.594,171.971Z",
    transform: "translate(-64.797 -17.608)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M484.193,182.093a3.667,3.667,0,1,0,3.667-3.665A3.667,3.667,0,0,0,484.193,182.093Z",
    transform: "translate(-62.001 -20.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M504.857,182.093a3.666,3.666,0,1,0,3.669-3.665A3.667,3.667,0,0,0,504.857,182.093Z",
    transform: "translate(-67.555 -20.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M494.594,192.357a3.666,3.666,0,1,0,3.667-3.667A3.666,3.666,0,0,0,494.594,192.357Z",
    transform: "translate(-64.797 -23.087)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M514.752,192.357a3.666,3.666,0,1,0,3.664-3.667A3.666,3.666,0,0,0,514.752,192.357Z",
    transform: "translate(-70.214 -23.087)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M514.752,217.879a3.666,3.666,0,1,0,3.664-3.667A3.666,3.666,0,0,0,514.752,217.879Z",
    transform: "translate(-70.214 -29.946)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M504.857,205.673a3.666,3.666,0,1,0,3.669-3.665A3.669,3.669,0,0,0,504.857,205.673Z",
    transform: "translate(-67.555 -26.666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M484.193,205.673a3.667,3.667,0,1,0,3.667-3.665A3.668,3.668,0,0,0,484.193,205.673Z",
    transform: "translate(-62.001 -26.666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M494.594,217.879a3.666,3.666,0,1,0,3.667-3.667A3.666,3.666,0,0,0,494.594,217.879Z",
    transform: "translate(-64.797 -29.946)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M504.857,227.689a3.666,3.666,0,1,0,3.669-3.668A3.666,3.666,0,0,0,504.857,227.689Z",
    transform: "translate(-67.555 -32.582)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M494.594,238.2a3.666,3.666,0,1,0,3.667-3.667A3.665,3.665,0,0,0,494.594,238.2Z",
    transform: "translate(-64.797 -35.406)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M504.857,248.6a3.666,3.666,0,1,0,3.669-3.669A3.667,3.667,0,0,0,504.857,248.6Z",
    transform: "translate(-67.555 -38.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M494.594,259.858a3.667,3.667,0,1,0,3.667-3.666A3.666,3.666,0,0,0,494.594,259.858Z",
    transform: "translate(-64.797 -41.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M491.527,248.6a3.667,3.667,0,1,0-3.667,3.664A3.667,3.667,0,0,0,491.527,248.6Z",
    transform: "translate(-62.001 -38.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M480.989,259.858a3.666,3.666,0,1,0-3.666,3.667A3.666,3.666,0,0,0,480.989,259.858Z",
    transform: "translate(-59.17 -41.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M484.193,270.617a3.667,3.667,0,1,0,3.667-3.667A3.666,3.666,0,0,0,484.193,270.617Z",
    transform: "translate(-62.001 -44.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M473.656,281.163a3.666,3.666,0,1,0,3.667-3.664A3.668,3.668,0,0,0,473.656,281.163Z",
    transform: "translate(-59.17 -46.954)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.852,291.643a3.667,3.667,0,1,0,3.668-3.667A3.667,3.667,0,0,0,462.852,291.643Z",
    transform: "translate(-56.266 -49.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M453.264,281.163a3.666,3.666,0,1,0,3.665-3.664A3.668,3.668,0,0,0,453.264,281.163Z",
    transform: "translate(-53.689 -46.954)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.852,270.617a3.667,3.667,0,1,0,3.668-3.667A3.667,3.667,0,0,0,462.852,270.617Z",
    transform: "translate(-56.266 -44.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M473.656,217.879a3.666,3.666,0,1,0,3.667-3.667A3.667,3.667,0,0,0,473.656,217.879Z",
    transform: "translate(-59.17 -29.946)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M484.193,227.689a3.667,3.667,0,1,0,3.667-3.668A3.665,3.665,0,0,0,484.193,227.689Z",
    transform: "translate(-62.001 -32.582)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M473.656,238.2a3.666,3.666,0,1,0,3.667-3.667A3.666,3.666,0,0,0,473.656,238.2Z",
    transform: "translate(-59.17 -35.406)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M470.186,248.6a3.667,3.667,0,1,0-3.666,3.664A3.668,3.668,0,0,0,470.186,248.6Z",
    transform: "translate(-56.266 -38.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M460.6,259.858a3.666,3.666,0,1,0-3.668,3.667A3.666,3.666,0,0,0,460.6,259.858Z",
    transform: "translate(-53.689 -41.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M450.2,270.617a3.667,3.667,0,1,0-3.667,3.666A3.666,3.666,0,0,0,450.2,270.617Z",
    transform: "translate(-50.894 -44.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M425.386,252.266a3.666,3.666,0,1,0-3.664-3.664A3.667,3.667,0,0,0,425.386,252.266Z",
    transform: "translate(-45.212 -38.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M432.936,259.858a3.668,3.668,0,1,0,3.669-3.666A3.667,3.667,0,0,0,432.936,259.858Z",
    transform: "translate(-48.226 -41.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M450.2,248.6a3.667,3.667,0,1,0-3.667,3.664A3.667,3.667,0,0,0,450.2,248.6Z",
    transform: "translate(-50.894 -38.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M453.264,238.2a3.666,3.666,0,1,0,3.665-3.667A3.666,3.666,0,0,0,453.264,238.2Z",
    transform: "translate(-53.689 -35.406)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M470.186,227.689a3.667,3.667,0,1,0-3.666,3.665A3.667,3.667,0,0,0,470.186,227.689Z",
    transform: "translate(-56.266 -32.582)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.852,205.673a3.667,3.667,0,1,0,3.668-3.665A3.668,3.668,0,0,0,462.852,205.673Z",
    transform: "translate(-56.266 -26.666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M480.989,192.357a3.666,3.666,0,1,0-3.666,3.666A3.667,3.667,0,0,0,480.989,192.357Z",
    transform: "translate(-59.17 -23.087)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.852,182.093a3.667,3.667,0,1,0,3.668-3.665A3.667,3.667,0,0,0,462.852,182.093Z",
    transform: "translate(-56.266 -20.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M456.929,175.638a3.666,3.666,0,1,0-3.665-3.666A3.667,3.667,0,0,0,456.929,175.638Z",
    transform: "translate(-53.689 -17.608)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M442.863,159.646a3.667,3.667,0,1,0,3.666-3.667A3.666,3.666,0,0,0,442.863,159.646Z",
    transform: "translate(-50.894 -14.296)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M429.055,159.646a3.667,3.667,0,1,0-3.669,3.666A3.668,3.668,0,0,0,429.055,159.646Z",
    transform: "translate(-45.212 -14.296)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M427.908,173.305a3.667,3.667,0,1,0-3.666,3.666A3.667,3.667,0,0,0,427.908,173.305Z",
    transform: "translate(-44.904 -17.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M416.787,148.519a3.667,3.667,0,1,0-3.666,3.666A3.667,3.667,0,0,0,416.787,148.519Z",
    transform: "translate(-41.915 -11.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M436.606,152.185a3.667,3.667,0,1,0-3.667-3.666A3.667,3.667,0,0,0,436.606,152.185Z",
    transform: "translate(-48.227 -11.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.522,138.253a3.667,3.667,0,1,0-3.664,3.666A3.666,3.666,0,0,0,406.522,138.253Z",
    transform: "translate(-39.156 -8.546)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M396.123,127.664a3.666,3.666,0,1,0-3.668,3.669A3.666,3.666,0,0,0,396.123,127.664Z",
    transform: "translate(-36.362 -5.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M378.525,116.718a3.666,3.666,0,1,0,3.664-3.667A3.666,3.666,0,0,0,378.525,116.718Z",
    transform: "translate(-33.603 -2.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M356.948,116.718a3.666,3.666,0,1,0,3.667-3.667A3.666,3.666,0,0,0,356.948,116.718Z",
    transform: "translate(-27.804 -2.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M378.525,138.253a3.666,3.666,0,1,0,3.664-3.666A3.666,3.666,0,0,0,378.525,138.253Z",
    transform: "translate(-33.603 -8.546)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M368.395,128.225a3.667,3.667,0,1,0,3.667-3.664A3.667,3.667,0,0,0,368.395,128.225Z",
    transform: "translate(-30.881 -5.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M396.123,148.519a3.666,3.666,0,1,0-3.668,3.666A3.668,3.668,0,0,0,396.123,148.519Z",
    transform: "translate(-36.362 -11.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.522,159.646a3.667,3.667,0,1,0-3.664,3.666A3.667,3.667,0,0,0,406.522,159.646Z",
    transform: "translate(-39.156 -14.296)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M388.791,171.468a3.666,3.666,0,1,0,3.664-3.666A3.666,3.666,0,0,0,388.791,171.468Z",
    transform: "translate(-36.362 -17.473)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M385.858,159.646a3.666,3.666,0,1,0-3.669,3.666A3.668,3.668,0,0,0,385.858,159.646Z",
    transform: "translate(-33.603 -14.296)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M375.729,148.519a3.667,3.667,0,1,0-3.667,3.666A3.668,3.668,0,0,0,375.729,148.519Z",
    transform: "translate(-30.881 -11.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M364.28,138.253a3.666,3.666,0,1,0-3.665,3.666A3.665,3.665,0,0,0,364.28,138.253Z",
    transform: "translate(-27.804 -8.546)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M375.729,172.466a3.667,3.667,0,1,0-3.667,3.666A3.667,3.667,0,0,0,375.729,172.466Z",
    transform: "translate(-30.881 -17.741)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M378.525,182.589a3.666,3.666,0,1,0,3.664-3.666A3.666,3.666,0,0,0,378.525,182.589Z",
    transform: "translate(-33.603 -20.462)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M382.189,200.666a3.666,3.666,0,1,0,3.669,3.667A3.666,3.666,0,0,0,382.189,200.666Z",
    transform: "translate(-33.603 -26.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M372.062,189.9a3.666,3.666,0,1,0,3.667,3.664A3.665,3.665,0,0,0,372.062,189.9Z",
    transform: "translate(-30.881 -23.411)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M356.948,182.589a3.666,3.666,0,1,0,3.667-3.666A3.666,3.666,0,0,0,356.948,182.589Z",
    transform: "translate(-27.804 -20.462)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M352.574,172.466a3.667,3.667,0,1,0-3.664,3.666A3.666,3.666,0,0,0,352.574,172.466Z",
    transform: "translate(-24.658 -17.741)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M332.389,138.415a3.225,3.225,0,1,0-3.223,3.227A3.223,3.223,0,0,0,332.389,138.415Z",
    transform: "translate(-19.471 -8.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M310.092,159.175a3.009,3.009,0,1,0-3.009,3.011A3.009,3.009,0,0,0,310.092,159.175Z",
    transform: "translate(-13.594 -14.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M258.264,204.723a2.388,2.388,0,1,0-2.388,2.385A2.387,2.387,0,0,0,258.264,204.723Z",
    transform: "translate(0 -26.754)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M289.926,204.723a2.387,2.387,0,1,0-2.387,2.385A2.386,2.386,0,0,0,289.926,204.723Z",
    transform: "translate(-8.509 -26.754)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M287.535,184.193a2.388,2.388,0,1,0-2.388,2.387A2.39,2.39,0,0,0,287.535,184.193Z",
    transform: "translate(-7.867 -21.236)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M310.092,183.681a3.009,3.009,0,1,0-3.009,3.011A3.009,3.009,0,0,0,310.092,183.681Z",
    transform: "translate(-13.594 -20.931)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M343.206,204.252a3.667,3.667,0,1,0-3.665,3.666A3.667,3.667,0,0,0,343.206,204.252Z",
    transform: "translate(-22.141 -26.283)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M321.853,204.414a3.226,3.226,0,1,0-3.225,3.225A3.225,3.225,0,0,0,321.853,204.414Z",
    transform: "translate(-16.639 -26.445)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M287.535,227.143a2.388,2.388,0,1,0-2.388,2.388A2.39,2.39,0,0,0,287.535,227.143Z",
    transform: "translate(-7.867 -32.779)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M310.092,226.914a3.009,3.009,0,1,0-3.009,3.01A3.007,3.007,0,0,0,310.092,226.914Z",
    transform: "translate(-13.594 -32.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M310.092,248.843a3.009,3.009,0,1,0-3.009,3.008A3.012,3.012,0,0,0,310.092,248.843Z",
    transform: "translate(-13.594 -38.443)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M332.389,238.357a3.225,3.225,0,1,0-3.223,3.223A3.225,3.225,0,0,0,332.389,238.357Z",
    transform: "translate(-19.471 -35.567)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M343.206,225.8a3.667,3.667,0,1,0-3.665,3.666A3.666,3.666,0,0,0,343.206,225.8Z",
    transform: "translate(-22.141 -32.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M352.574,214.092a3.667,3.667,0,1,0-3.664,3.666A3.666,3.666,0,0,0,352.574,214.092Z",
    transform: "translate(-24.658 -28.928)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M364.28,225.8a3.666,3.666,0,1,0-3.665,3.666A3.665,3.665,0,0,0,364.28,225.8Z",
    transform: "translate(-27.804 -32.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M352.574,238.2a3.667,3.667,0,1,0-3.664,3.666A3.666,3.666,0,0,0,352.574,238.2Z",
    transform: "translate(-24.658 -35.406)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M339.541,252.266a3.666,3.666,0,1,0-3.668-3.664A3.667,3.667,0,0,0,339.541,252.266Z",
    transform: "translate(-22.141 -38.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M332.389,270.779a3.225,3.225,0,1,0-3.223,3.227A3.225,3.225,0,0,0,332.389,270.779Z",
    transform: "translate(-19.471 -44.281)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M352.574,259.858a3.667,3.667,0,1,0-3.664,3.667A3.666,3.666,0,0,0,352.574,259.858Z",
    transform: "translate(-24.658 -41.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M352.574,148.519a3.667,3.667,0,1,0-3.664,3.666A3.667,3.667,0,0,0,352.574,148.519Z",
    transform: "translate(-24.658 -11.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M364.28,248.6a3.666,3.666,0,1,0-3.665,3.664A3.667,3.667,0,0,0,364.28,248.6Z",
    transform: "translate(-27.804 -38.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M339.541,163.313a3.667,3.667,0,1,0-3.668-3.666A3.667,3.667,0,0,0,339.541,163.313Z",
    transform: "translate(-22.141 -14.296)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M364.28,159.646a3.666,3.666,0,1,0-3.665,3.666A3.667,3.667,0,0,0,364.28,159.646Z",
    transform: "translate(-27.804 -14.296)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M368.395,237.22a3.667,3.667,0,1,0,3.667-3.666A3.666,3.666,0,0,0,368.395,237.22Z",
    transform: "translate(-30.881 -35.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M382.189,252.266a3.666,3.666,0,1,0-3.664-3.664A3.667,3.667,0,0,0,382.189,252.266Z",
    transform: "translate(-33.603 -38.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M368.395,259.858a3.667,3.667,0,1,0,3.667-3.666A3.667,3.667,0,0,0,368.395,259.858Z",
    transform: "translate(-30.881 -41.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M364.28,270.617a3.666,3.666,0,1,0-3.665,3.666A3.665,3.665,0,0,0,364.28,270.617Z",
    transform: "translate(-27.804 -44.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M352.574,281.163a3.667,3.667,0,1,0-3.664,3.67A3.667,3.667,0,0,0,352.574,281.163Z",
    transform: "translate(-24.658 -46.954)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M352.574,126.746a3.667,3.667,0,1,0-3.664,3.666A3.667,3.667,0,0,0,352.574,126.746Z",
    transform: "translate(-24.658 -5.454)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M364.28,291.643a3.666,3.666,0,1,0-3.665,3.666A3.666,3.666,0,0,0,364.28,291.643Z",
    transform: "translate(-27.804 -49.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M382.189,295.309a3.666,3.666,0,1,0-3.664-3.666A3.667,3.667,0,0,0,382.189,295.309Z",
    transform: "translate(-33.603 -49.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M375.729,281.163a3.667,3.667,0,1,0-3.667,3.67A3.668,3.668,0,0,0,375.729,281.163Z",
    transform: "translate(-30.881 -46.954)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M396.123,259.858a3.666,3.666,0,1,0-3.668,3.667A3.667,3.667,0,0,0,396.123,259.858Z",
    transform: "translate(-36.362 -41.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M385.858,270.617a3.666,3.666,0,1,0-3.669,3.666A3.667,3.667,0,0,0,385.858,270.617Z",
    transform: "translate(-33.603 -44.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M396.123,281.163a3.666,3.666,0,1,0-3.668,3.67A3.667,3.667,0,0,0,396.123,281.163Z",
    transform: "translate(-36.362 -46.954)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M399.188,270.617a3.667,3.667,0,1,0,3.669-3.667A3.667,3.667,0,0,0,399.188,270.617Z",
    transform: "translate(-39.156 -44.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M416.787,281.163a3.667,3.667,0,1,0-3.666,3.67A3.667,3.667,0,0,0,416.787,281.163Z",
    transform: "translate(-41.915 -46.954)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.522,291.643a3.667,3.667,0,1,0-3.664,3.666A3.667,3.667,0,0,0,406.522,291.643Z",
    transform: "translate(-39.156 -49.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M396.123,301.553a3.666,3.666,0,1,0-3.668,3.666A3.667,3.667,0,0,0,396.123,301.553Z",
    transform: "translate(-36.362 -52.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M409.454,301.553a3.667,3.667,0,1,0,3.667-3.667A3.667,3.667,0,0,0,409.454,301.553Z",
    transform: "translate(-41.915 -52.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M429.055,291.643a3.667,3.667,0,1,0-3.669,3.666A3.668,3.668,0,0,0,429.055,291.643Z",
    transform: "translate(-45.212 -49.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M432.939,301.553a3.667,3.667,0,1,0,3.667-3.667A3.665,3.665,0,0,0,432.939,301.553Z",
    transform: "translate(-48.227 -52.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M450.2,291.643a3.667,3.667,0,1,0-3.667,3.666A3.667,3.667,0,0,0,450.2,291.643Z",
    transform: "translate(-50.894 -49.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M440.271,281.163a3.668,3.668,0,1,0-3.667,3.67A3.667,3.667,0,0,0,440.271,281.163Z",
    transform: "translate(-48.226 -46.954)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M429.055,270.617a3.667,3.667,0,1,0-3.669,3.666A3.667,3.667,0,0,0,429.055,270.617Z",
    transform: "translate(-45.212 -44.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M416.787,259.858a3.667,3.667,0,1,0-3.666,3.667A3.666,3.666,0,0,0,416.787,259.858Z",
    transform: "translate(-41.915 -41.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.522,248.6a3.667,3.667,0,1,0-3.664,3.664A3.667,3.667,0,0,0,406.522,248.6Z",
    transform: "translate(-39.156 -38.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M392.455,232.68a3.666,3.666,0,1,0,3.668,3.667A3.665,3.665,0,0,0,392.455,232.68Z",
    transform: "translate(-36.362 -34.909)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M385.858,228.474a3.666,3.666,0,1,0-3.669,3.667A3.667,3.667,0,0,0,385.858,228.474Z",
    transform: "translate(-33.603 -32.793)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M375.729,214.092a3.667,3.667,0,1,0-3.667,3.666A3.668,3.668,0,0,0,375.729,214.092Z",
    transform: "translate(-30.881 -28.928)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M360.615,206.749a3.666,3.666,0,1,0-3.667-3.666A3.666,3.666,0,0,0,360.615,206.749Z",
    transform: "translate(-27.804 -25.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M352.574,193.277a3.667,3.667,0,1,0-3.664,3.669A3.664,3.664,0,0,0,352.574,193.277Z",
    transform: "translate(-24.658 -23.335)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M343.206,183.44a3.667,3.667,0,1,0-3.665,3.664A3.666,3.666,0,0,0,343.206,183.44Z",
    transform: "translate(-22.141 -20.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M332.389,173.054a3.225,3.225,0,1,0-3.223,3.224A3.223,3.223,0,0,0,332.389,173.054Z",
    transform: "translate(-19.471 -18.017)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSebraeOne);
export default __webpack_public_path__ + "static/media/logo-sebrae-one.e4772dc45a9c303c980017c152d00ff4.svg";
export { ForwardRef as ReactComponent };